import NiceModal from '@ebay/nice-modal-react';
import { Center } from '@mantine/core';

import { useAccount } from '../../../auth';
import { Platform } from '../../types';

import { AddInstConnectButton } from './AddInstConnectButton';
import { AddInstFacebookPagesButton } from './AddInstFacebookPagesButton';
import { AddInstViaSystemUserPagesButton } from './AddInstViaSystemUserPagesButton';
import { AddTgPageModal } from './AddTgPageModal';

import { AddButton } from '@/components';
import { Departments } from '@/types';

type Props = {
  platform: Platform;
  department: Departments;
  isLoading: boolean;
};

export const AddPageButton = ({ platform, department, isLoading }: Props) => {
  const getAccount = useAccount();
  const isFacebookLogin = !!getAccount.data?.account.isFacebookLogin;

  if (platform === 'telegram') {
    return (
      <AddButton
        isLoading={isLoading}
        onClick={() => NiceModal.show(AddTgPageModal, { department })}
      />
    );
  }

  if (platform === 'instagram') {
    return (
      <Center style={{ gap: 8 }}>
        {isFacebookLogin ? (
          <AddInstFacebookPagesButton isLoading={isLoading} department={department} />
        ) : (
          <AddInstViaSystemUserPagesButton isLoading={isLoading} department={department} />
        )}
        <AddInstConnectButton isLoading={isLoading} department={department} />
      </Center>
    );
  }

  return null;
};
